import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <h1>Nicki Anselmo</h1>
    </div>
  );
}
